import { t } from './../i18n';
import config from './../config/index';

const IS_I18N = process.env.IS_I18N === 'true';
export const renderI18nText = () => {
  renderTitle(config.APP_NAME);
  renderElement(t('请选择“用系统默认浏览器打开”'), 'wxwork-tips');
  renderElement(`- ${t('欢迎使用{{appname}}', {
    appname: config.APP_NAME,
  })} - `, 'welcome-tips');
  renderElement(t('查看我的会议列表'), 'dropdownTxtCtrl');
  renderElement(t('切换账号'), 'change-account');
  renderElement(t('限量'), 'limit-text');
  renderElement(t('添加到我的会议'), 'collect-meeting');
  renderElement(t('已添加到我的会议'), 'already-collect');
  renderElement(t('点击此处'), 'click-here-collect');
  renderElement(t('将此会议添加至我的会议列表，随时查看会议安排'), 'click-tips');
  renderElement(t('知道了'), 'click-confirm');
  renderElement(t('知道了'), 'win-click-confirm');
  renderElement(t('电话入会'), 'telJoinBtnCtrl');
  renderElement(t('小程序入会'), 'mpJoinBtnCtrl');
  renderElement(t('加入会议'), 'joinBtnCtrl');
  renderElement(t('浏览器入会'), 'webJoinBtnCtrl');
  renderElement(t('会议已设置密码，请联系主持人获取'), 'passwordTip');
  renderElement(t('会议号无效'), 'msgWrapTxtCtrl');
  renderElement(t('您可以<span class="copy-meeting-invitation-text" onclick="pageDetail.clickCopyMeetingUrl()">复制会议邀请</span>，发送至会议成员'), 'footTxtCtrl');
  renderElement(t('您可以<span class="copy-meeting-invitation-text" onclick="pmiPageDetail.clickCopyMeetingUrl()">复制会议邀请</span>，发送至会议成员'), 'footTxtCtrl-pmi');
  renderElement(t('若无法正常跳转请先点击【立即下载】按钮或<span class="link" onclick="pmiPageDetail.goToConferenceDetail()">返回会议详情</span>使用其他方式加入会议。'), 'i18n-tencentMeetingDescFirstTxt')
  renderElement(t('若您已经安装了腾讯会议，请点击右上角，用浏览器打开。'), 'i18n-mobile-device-tips1')
  renderElement(t('若您已安装了腾讯会议，请<span class="link" onclick="pmiPageDownloadGuide.onClickLaunchAppOnLink()">点击此处</span>。如果浏览器对话框弹出，请点击【打开腾讯会议】按钮。'), 'i18n-pc-device-tips1')
  renderElement(t('请使用微信扫描小程序码'), 'mini-pro-tips');
  renderElement(t('加入会议'), 'mini-pro-join');
  renderTelEntryDialogCtrl();
  renderMQrcodeDialog();
  renderQrcodeDialogCtrl2();
  renderElement(t('下载'), 'qrcode-download');
  renderElement(t('点击 ··· 并选择“在浏览器中打开”'), 'andr-guid');
  renderElement(t('请点击左上角工具栏“用默认浏览器打开”'), 'win-click-tips');
  renderLaunchAppContainer();
  renderElement(t('请在移动端打开此链接'), 'tm-qrcode-in-pc');
  renderNotValidTips();
  renderElement(t('请使用手机端「{{appname}} App」扫码入会', {
    appname: config.APP_NAME,
  }), 'qrcode-jointips');
  renderElement(t('长按保存图片'), 'qrcodeSave');
  renderElement(t('已加密'), 'meeting-encode');
  renderElement(t('个人会议号'), 'pmi-meeting-num');
  renderElement(t('个人会议号是会议邀请者的固定会议号，该会议长期有效。'), 'pmi-code-info1');
  renderElement(t('仅1.3.5及以上版本才可加入该会议'), 'pmi-code-info2');
  renderElement(t('请点击左上角工具栏“用默认浏览器打开”'), 'click-tips-wechat');
};

const renderTitle = (title) => {
  document.title = title;
};

const renderElement = (html, id) => {
  if (document.getElementById(id)) {
    document.getElementById(id).innerHTML = html;
  }
};

const renderElementByClass = (html, className) => {
  if (document.getElementsByClassName(className)
    && document.getElementsByClassName(className).length) {
    Array.from(document.getElementsByClassName(className)).forEach(($el) => {
      const el = $el;
      el.innerHTML = html;
    });
  }
};

const renderTelEntryDialogCtrl = () => {
  renderElement(t('请选择您所在地区的电话入会'), 'telentry-tips');
  renderElement(`(${t('中国大陆')}) `, 'telentry-cn');
  renderElement(`(${t('中国香港')}) `, 'telentry-hk');
  renderElement(`(${t('美国')}) `, 'telentry-usa');
  renderElementByClass(t('复制'), 'item-btn');
};

const renderMQrcodeDialog = () => {
  renderElement(t('请选择您所在地区的电话入会'), 'mQrcodeDialog-tips');
  renderElement(`(${t('中国大陆')})`, 'mQrcodeDialog-cn');
  renderElement(`(${t('中国香港')})`, 'mQrcodeDialog-hk');
  renderElement(`(${t('美国')})`, 'mQrcodeDialog-usa');
  renderElement(t('取消'), 'mQrcodeDialog-cancel');
};

const renderQrcodeDialogCtrl2 = () => {
  renderElement(t('微信中长按识别小程序码'), 'qrcodeDialogCtrl2-tips');
  renderElement(`(${t('加入会议')})`, 'qrcodeDialogCtrl2-join');
};

export const renderLaunchAppContainer = () => {
  renderElement(t('特邀'), 'tm-specially-invited-meeting-text');
  renderElement(t('该页面会唤起{{appname}}', {
    appname: config.APP_NAME,
  }), 'tm-meeting-logo-txt');
  renderElement(t('正在唤起{{appname}}...', {
    appname: config.APP_NAME,
  }), 'tm-specially-invited-meeting-logo-txt');
  renderElement(t('若无法正常跳转请先点击【立即下载】按钮'), 'tencentMeetingDescFirstTxt');
  renderElement(t('或'), 'desc-and');
  renderElement(t('返回会议详情'), 'desc-back');
  renderElement(t('使用其他方式加入会议'), 'desc-others');
  renderElement(t('若您已经安装了{{appname}}', {
    appname: config.APP_NAME,
  }), 'mobile-tips1');
  renderElement(t('请点击右上角，用浏览器打开'), 'mobile-tips2');
  renderElement(t('若您已安装了{{appname}}，请', {
    appname: config.APP_NAME,
  }), 'pc-device-tips1');
  renderElement(t('点击此处'), 'pc-device-tips2');
  renderElement(t('若您已安装了{{appname}}，请', {
    appname: config.APP_NAME,
  }), 'pc-device-tips3');
  renderElement(t('点击此处'), 'pc-device-tips4');
  renderElement(t('或通过'), 'pc-web-wemeet-tip-1');
  renderElement(t('浏览器加入会议'), 'pc-web-wemeet-tip-2');
  renderElement(t('如果浏览器对话框弹出，请点击【打开{{appname}}】按钮', {
    appname: config.APP_NAME,
  }), 'pc-device-tips5');
  renderElement(t('仅1.8.0及以上版本才可发送特邀会议邀请'), 'invited-meeting-desc1');
  renderElement(t('若无法正常唤起，'), 'invited-meeting-desc2');
  renderElement(t('请下载最新版本后重试'), 'invited-meeting-desc3');
  renderElement(t('立即下载'), 'joinBtnCtrlLanuch');
  renderElement(t('如果您使用非中国大陆地区手机号码，请点击前往'), 'voov-download-tips1');
  renderElement(t('下载 VooV Meeting'), 'voov-download-tips2');
  renderElement(t('如果您使用中国大陆地区手机号码，请点击前往'), 'tencent-download-tips1');
  renderElement(IS_I18N ? t('下载 腾讯会议') : t('下载 {{appname}}', {
    appname: config.APP_NAME,
  }), 'tencent-download-tips2');
  renderElement(t('点击 ··· 并选择“在浏览器中打开”'), 'andr-hint-tips');
};

const renderNotValidTips = () => {
  renderElement(t('会议邀请无效'), 'invalid-tips');
  renderElement(t('仅1.8.0及以上版本可发送有效的特邀会议邀请'), 'invalid-version');
};
